import { render } from "./JSONResult.vue?vue&type=template&id=2475a622&scoped=true"
import script from "./JSONResult.vue?vue&type=script&lang=js"
export * from "./JSONResult.vue?vue&type=script&lang=js"

import "./JSONResult.vue?vue&type=style&index=0&id=2475a622&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2475a622"]])

export default __exports__